import React from 'react'

import { TableTypes } from 'types'

interface Props {
    variant: 'primary' | 'secondary'
    data: Object[],
    columns: TableTypes.ColumnItem[],
    onRowClick?: Function
}

export default class Table extends React.Component<Props> {

    public handleClick = (data: Object) => {
       if (this.props.onRowClick) {
           this.props.onRowClick(data)
       }
    }

    public render() {

        const tableVariant = 'table table--' + this.props.variant

        return (
            <React.Fragment>
                {this.props.data.length > 0 ?
                    <table id="table-current" className={tableVariant}>
                        <thead>
                            <tr>
                                {this.props.columns.map((columnItem: TableTypes.ColumnItem, index: number) =>
                                    <th key={index}>{columnItem.header}</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.data.map((dataItem: Object, dataIndex: number) =>
                                <tr key={dataIndex} onClick={(e) => this.handleClick(dataItem)}>
                                    {this.props.columns
                                        .map((colItem: TableTypes.ColumnItem, colIndex: number) => {
                                            if (colItem.cell && typeof colItem.cell === 'function') {
                                                return <td key={colIndex}>{colItem.cell(dataItem)}</td>
                                            } else {
                                                if (typeof colItem.accessor === 'function') {
                                                    return <td key={colIndex}>{colItem.accessor(dataItem)}</td>
                                                } else {
                                                    return <td key={colIndex}>{dataItem[`${colItem.accessor}`]}</td>
                                                }
                                            }
                                        })
                                    }
                                </tr>
                            )}
                        </tbody>
                    </table> :
                    <h3 className="u-padding-left--md">No results</h3>
                }
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/index.tsx